import type { TransportErrorKind } from '../api/api.retry';

type TransportErrorCaptureInput = {
  errorKind: TransportErrorKind | 'backend-connection';
  host: string;
  isOnline: boolean;
};

type TransportErrorCaptureDecision = {
  shouldCapture: boolean;
  suppressedCount: number;
  windowMs: number;
};

type TransportErrorCaptureWindow = {
  capturedAt: number;
  suppressedCount: number;
};

const windowMs = 5 * 60 * 1_000;
const captureWindows = new Map<string, TransportErrorCaptureWindow>();

export const transportErrorCapturePolicy = {
  evaluate({
    errorKind,
    host,
    isOnline,
  }: TransportErrorCaptureInput): TransportErrorCaptureDecision {
    if (!isOnline) {
      return { shouldCapture: false, suppressedCount: 0, windowMs };
    }

    const key = `${host}:${errorKind}`;
    const now = Date.now();
    const current = captureWindows.get(key);

    if (
      current &&
      now >= current.capturedAt &&
      now - current.capturedAt < windowMs
    ) {
      current.suppressedCount += 1;
      return { shouldCapture: false, suppressedCount: 0, windowMs };
    }

    const suppressedCount = current?.suppressedCount ?? 0;
    captureWindows.set(key, { capturedAt: now, suppressedCount: 0 });

    return { shouldCapture: true, suppressedCount, windowMs };
  },

  reset() {
    captureWindows.clear();
  },
};
